import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { NgbModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from 'src/app/shared/_service/session.service';
import { ApiService } from 'src/app/shared/_service/api.service';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ProductService } from 'src/app/shared/_service/product.service';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { get } from 'jquery';
import { debounceTime, tap } from 'rxjs/operators';
import { ReturnStatement } from '@angular/compiler';

@Component({
	selector: 'app-carrello',
	templateUrl: './carrello.component.html',
})
export class CarrelloComponent implements OnInit, OnDestroy {
	constructor(
		private modalService: NgbModal,
		private session: SessionService,
		private translate: TranslateService,
		private auth: AuthService,
		private router: Router,
		private api: ApiService,
		private productService: ProductService,
	) {}

	alertMessage;
	scontoPercentualeTotale = 0;

	carrello = [];
	totaleItems = 0;
	totaleSoldi = 0;

	indirizzi = [];

	/* valori: 
  undefined -> select non selezionata
  null -> select selezionata con indirizzo principale
  "string" -> select selezionata con indirizzo secondario
  */
	codiceIndirizzo;

	hideImages = false;
	success = false;

	jsonInMail: any = {};
	mailError = '';
	isPartner = this.auth.isPartner;

	// calendario
	dateSelected?: NgbDate;
	rifOrdineCliente;

	idNeutral = environment.idNeutral;

	subs: Subscription[] = [];

	showContainerizzazione = false;

	utente = this.auth.getUser();

	$updateQuantita = new EventEmitter<{ item: any; qta: number }>();

	get toaleScontato() {
		let totale = 0;
		this.carrello.forEach((item) => {
			totale += item.quantita * (item.scontoAssolutoRichiesto || item.prodottoCommerciale.listini[0].prezzoNetto);
		});
		return totale;
	}

	get buyDisabled() {
		return this.isPartner || this.codiceIndirizzo === undefined;
	}

	ngOnInit() {
		const user = this.auth.getUser();
		this.showContainerizzazione = user.containerizzazioneCarrello;
		this.indirizzi = this.auth.getUser().cliente.indirizziSpedizione.filter((i) => !i.cancellato); // undefined = select non selezionata | null = select selezionata con indirizzo principale
		this.codiceIndirizzo = this.session.get('indirizzo') || this.indirizzi.length > 0 ? undefined : null;
		this.session.updateCarrello();

		console.log('USER: ', user);

		this.subs.push(
			this.session.carrelloChange.subscribe((c) => {
				this.carrello = c;
				this.totaleItems = 0;
				this.totaleSoldi = 0;
				c.forEach((item) => {
					item.prodottoCommerciale.listini = item.prodottoCommerciale.listini.filter((l) => l.cliente === user.cliente.codiceCliente);

					this.totaleItems += item.quantita;
					this.totaleSoldi += item.quantita * this.getPrezzo(item);

					if (this.idNeutral.includes(item.prodottoCommerciale.prodotto.lineaEstetica)) {
						item.prodottoCommerciale.isNeutral = true;
					}

					item.prodottoCommerciale.imgIndex = 0;
					item.prodottoCommerciale.giacenzaMagazzino = this.productService.calcolaGiacenzaMagazzino(item.prodottoCommerciale);

					if (this.auth.getUser().leadTimeAttivo) {
						const leadTimeCalcolato = this.addBusinessDays(
							moment(),
							item.prodottoCommerciale.leadTime + this.auth.getUser().cliente.mercato[0].leadTime,
						);
						item.leadTimeCalcolato = leadTimeCalcolato;
					}
				});
				console.log('Carrello: ', this.carrello);
				this.controllaMoq();
			}),
		);

		this.$updateQuantita
			.pipe(
				tap(({ item, qta }) => {
					if (item) {
						if (qta < 1) {
							item.quantita = 1;
						} else if (qta > 500) {
							item.quantita = 500;
						} else if (
							item.prodottoCommerciale.statoGiacenza === 'IN_STOCK' &&
							item.prodottoCommerciale.giacenza <= qta &&
							this.utente.company.connettore !== 'SAGEX3'
						) {
							item.quantita = item.prodottoCommerciale.giacenza;
						}
						item.quantita = qta;
					}
				}),
				debounceTime(1000),
			)
			.subscribe(({ item, qta }) => {
				this.session.setCarrello(item.prodottoCommerciale.codiceTecnico, item.quantita, false).subscribe();
			});
	}

	ngOnDestroy(): void {
		this.subs.forEach((s) => s.unsubscribe());
	}

	controllaMoq() {
		const prodottiErroreMoq = this.carrello.filter((prodottoCarrello: any) => {
			prodottoCarrello.erroreMoq = false;
			const prodottoCommerciale = prodottoCarrello.prodottoCommerciale;
			const listino = prodottoCommerciale.listini[0];
			if (listino.moqAbilitato && prodottoCommerciale.moqVendita && prodottoCarrello.quantita < prodottoCommerciale.moqVendita) {
				prodottoCarrello.erroreMoq = true;
				return true;
			}
		});
		console.log('controllaMoq', prodottiErroreMoq);
		return !prodottiErroreMoq.length;
	}

	delete(item) {
		this.session
			.setCarrello(item.prodottoCommerciale.codiceTecnico, 0, false)
			.subscribe(() => this.carrello.splice(this.carrello.indexOf(item), 1));
	}

	getDescrizione(prodottoCommerciale) {
		return (
			prodottoCommerciale.descrizioni.find((d) => d.lingua.codice === 'US') ||
			prodottoCommerciale.prodotto.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}

	buy(modaleDataRichiesta, confirm) {
		if (!this.controllaMoq()) {
			return alert('There are some products below the minimum order quantity.');
		}

		if (this.carrello.find((item) => item.prodottoCommerciale.immagini.length > 1)) {
			this.modalService
				.open(confirm, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' })
				.result.then((res) => {
					this.modalService.open(modaleDataRichiesta, { ariaLabelledBy: 'modal-basic-title' });
				})
				.catch(() => {});
		} else {
			this.modalService.open(modaleDataRichiesta, { ariaLabelledBy: 'modal-basic-title' });
		}
	}

	openMail(contentMail) {
		const user = this.auth.getUser();
		this.jsonInMail.sender = environment.mailFrom;
		this.jsonInMail.recipients = user.email;
		this.modalService.open(contentMail, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
	}

	sendOrder(modal, alertModal) {
		const dataConsegnaRichiesta = new Date(this.dateSelected.year, this.dateSelected.month - 1, this.dateSelected.day);
		dataConsegnaRichiesta.setMinutes(dataConsegnaRichiesta.getMinutes() - dataConsegnaRichiesta.getTimezoneOffset());
		const oggi = new Date();
		oggi.setHours(0, 0, 0, 0);
		oggi.setMinutes(oggi.getMinutes() - oggi.getTimezoneOffset());
		console.log('dataConsegnaRichiesta: ', dataConsegnaRichiesta);
		if (dataConsegnaRichiesta <= oggi) {
			return alert('The delivery date must be in the future');
		}

		const jsonIn = {
			dataConsegnaRichiesta,
			codiceIndirizzoSpedizioneAS400: this.codiceIndirizzo,
			rifOrdineCliente: this.rifOrdineCliente,
		};

		this.api.saveOrdine(jsonIn).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.session.getCarrello().subscribe((carrello) => (this.carrello = carrello));
				modal.close();
				this.success = true;
			} else {
				const msg = res.descrizione.split('#')[0];
				const code = res.descrizione.split('#')[1];
				this.translate.get(msg).subscribe((msgTrad) => {
					this.alertMessage = msgTrad.replace('#CODICE_COMMERCIALE', code);
					this.modalService.open(alertModal, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
				});
			}
		});
	}

	svuota() {
		this.session.svuotaCarrello();
	}

	indirizzoChange($event) {
		this.session.set('indirizzo', $event);
	}

	print() {
		window.print();
	}

	sendMail(contentMail, mailSuccess) {
		this.mailError = '';
		this.jsonInMail.codice_lingua = this.translate.currentLang;
		this.api.sendMailCarrello(this.jsonInMail).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.jsonInMail = {};
				contentMail.close();
				this.modalService.open(mailSuccess, { ariaLabelledBy: 'modal-basic-title' }).result.then(() => {});
			} else {
				this.mailError = res.descrizione;
			}
		});
	}

	getPdfCarrello() {
		this.api.getPdfCarrello({ codice_lingua: this.translate.currentLang }).subscribe((blob) => {
			const URL = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.href = URL;
			a.download = 'Bertazzoni Shopping Cart.pdf';
			a.click();
			window.URL.revokeObjectURL(URL);
			a.remove();
		});
	}

	addBusinessDays(originalDate, numDaysToAdd) {
		const Sunday = 0;
		const Saturday = 6;
		let daysRemaining = numDaysToAdd;
		const newDate = originalDate.clone();
		while (daysRemaining > 0) {
			newDate.add(1, 'days');
			if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
				daysRemaining--;
			}
		}
		return newDate;
	}

	viewContainer() {
		this.api.getSpedizioneCarrello().subscribe((spedizione) => {
			if (!spedizione) {
				this.api
					.saveSpedizione({
						tipoSpedizione: 'CARRELLO',
					})
					.subscribe((newSpedizione) => this.router.navigate(['/edit-container', newSpedizione.id]));
			} else {
				this.router.navigate(['/edit-container', spedizione.id]);
			}
		});
	}

	getPrezzo(item) {
		if (this.utente.company.connettore === 'SAGEX3') {
			return item.prezzoUnitarioOriginale;
		}
		const listino = item.prodottoCommerciale.listini[0];
		return listino ? listino.prezzoNetto : 0;
	}

}
